import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import {
    LoadingDiv,
    SweetAlertShow,
} from "../../master/Master";

import {
    getStudentAttendanceList,
} from "./Master";

import {
    studentAttendancePost,
    studentAttendanceSendMessage,
    studentAttendancePresentSendMessage,
    studentAttendanceAbsentSendMessage,
    studentAttendanceBatchMarkPost,
} from "../../../api/Attendance";

import { formatToTime } from "../../master/FormatToDateTime";


export default function StudentAttendanceMesstable({
    filters,
    setFilters,
    isModal = false,
}) {

    const [loading, setLoading] = useState(false);

    const [metaEnabled, setMetaEnabled] = useState(false);

    const [data, setData] = useState({

        total: 0,
        present: 0,
        absent: 0,
        no_mark: 0,

        push_not_send: 0,
        push_send: 0,
        push_processing: 0,
        push_failed: 0,

        not_send: 0,
        send: 0,
        processing: 0,
        failed: 0,

        data: [],
    });

    useEffect(() => {

        try {

            const instituteData =
                JSON.parse(
                    localStorage.getItem("setting")
                ) || {};

            const isMetaEnabled =
                String(
                    instituteData?.message_status ?? ""
                ).toLowerCase() === "yes";

            setMetaEnabled(isMetaEnabled);

        } catch (error) {

            console.error(
                "Unable to read Meta WhatsApp setting:",
                error
            );

            setMetaEnabled(false);

        }

    }, []);


    /*
    |--------------------------------------------------------------------------
    | GET DATA
    |--------------------------------------------------------------------------
    */

    const handleFunction = () => {

        getStudentAttendanceList({
            setLoading,
            filters,
            setData,
        });

    };


    /*
    |--------------------------------------------------------------------------
    | LOAD DATA
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (
            !filters?.session_id ||
            !filters?.date
        ) {
            return;
        }

        if (isModal) {
            handleFunction();
            return;
        }

        if (
            filters?.course_id ||
            filters?.batch_id
        ) {
            handleFunction();
        }

    }, [
        isModal,
        filters?.session_id,
        filters?.course_id,
        filters?.batch_id,
        filters?.staff_id,
        filters?.date,
        filters?.attendance,
        filters?.message_filter,
    ]);


    /*
    |--------------------------------------------------------------------------
    | UPDATE SINGLE ATTENDANCE
    |--------------------------------------------------------------------------
    */

    const updateAttendance = async (
        registration_no,
        type
    ) => {

        setLoading(true);

        const formData = new FormData();

        formData.append("registration_no", registration_no);
        formData.append("type", type);
        formData.append("date", filters?.date);

        try {

            const response =
                await studentAttendancePost(formData);

            if (response?.data?.status) {

                SweetAlertShow(
                    "success",
                    "Successfully",
                    response?.data?.message
                );

            } else {

                SweetAlertShow(
                    "info",
                    "Warning",
                    response?.data?.message
                );

            }

        } catch (error) {

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.message
            );

        } finally {

            setLoading(false);

            handleFunction();

        }

    };


    const handleAttendanceAction = async () => {

        setLoading(true);

        try {

            const attendanceFilter =
                filters?.attendance ?? "";

            const batchId =
                filters?.batch_id ?? "";

            const date =
                filters?.date ?? "";

            let response = null;


            /* ---------------- ALL ---------------- */

            if (attendanceFilter === "") {

                const params = new URLSearchParams();

                if (batchId) {
                    params.append("batch_id", batchId);
                }

                if (date) {
                    params.append("date", date);
                }

                response =
                    await studentAttendanceSendMessage(
                        params.toString()
                    );

            }


            /* ---------------- PRESENT ---------------- */

            else if (attendanceFilter === "1") {

                const params = new URLSearchParams();

                if (batchId) {
                    params.append("batch_id", batchId);
                }

                if (date) {
                    params.append("date", date);
                }

                response =
                    await studentAttendancePresentSendMessage(
                        params.toString()
                    );

            }


            /* ---------------- ABSENT ---------------- */

            else if (attendanceFilter === "2") {

                const params = new URLSearchParams();

                if (batchId) {
                    params.append("batch_id", batchId);
                }

                if (date) {
                    params.append("date", date);
                }

                response =
                    await studentAttendanceAbsentSendMessage(
                        params.toString()
                    );

            }


            /* ---------------- NOT MARKED ---------------- */

            else if (attendanceFilter === "0") {

                const formData = new FormData();

                if (filters?.session_id) {
                    formData.append("session_id", filters.session_id);
                }

                if (batchId) {
                    formData.append("batch_id", batchId);
                }

                if (date) {
                    formData.append("date", date);
                }

                response =
                    await studentAttendanceBatchMarkPost(
                        formData
                    );

            }


            if (response?.data?.status) {

                SweetAlertShow(
                    "success",
                    "Successfully",
                    response?.data?.message ??
                    "Attendance processed successfully"
                );

            } else {

                SweetAlertShow(
                    "info",
                    "Warning",
                    response?.data?.message ??
                    "No attendance data found"
                );

            }

        } catch (error) {

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.message ??
                "Something went wrong"
            );

        } finally {

            setLoading(false);

            handleFunction();

        }

    };


    /*
    |--------------------------------------------------------------------------
    | MAIN BUTTON (text, description, icon, color filter ke hisab se badalta hai)
    |
    | Button ka text ya color badalna ho to yaha change karo.
    | description = confirm popup me dikhne wala text.
    |--------------------------------------------------------------------------
    */

    const getAttendanceAction = () => {

        switch (filters?.attendance) {

            case "1":
                return {
                    text: "Send Present Message",
                    description: "An attendance message will be sent to all students marked as Present. Do you want to continue?",
                    icon: "ri-user-follow-line",
                    className: "btn btn-success",
                };

            case "2":
                return {
                    text: "Send Absent Message",
                    description: "An attendance message will be sent to all students marked as Absent. Do you want to continue?",
                    icon: "ri-user-unfollow-line",
                    className: "btn btn-danger",
                };

            // case "0":
            //     return {
            //         text: "Selected Students as Absent Mark",
            //         description: "Students whose attendance is not marked will be marked as Absent. Do you want to continue?",
            //         icon: "ri-user-forbid-line",
            //         className: "btn btn-warning",
            //     };

            default:
                return {
                    text: "Selected Present/Absent Message Send",
                    description: "Present/Absent messages will be sent to the selected students. Do you want to continue?",
                    icon: "ri-send-plane-line",
                    className: "btn btn-primary",
                };

        }

    };

    const attendanceAction = getAttendanceAction();


    /*
    |--------------------------------------------------------------------------
    | CONFIRM POPUP (button click par pehle ye chalega)
    |
    | title       = button ka naam
    | text        = description
    | Yes dabane par hi handleAttendanceAction chalega.
    |--------------------------------------------------------------------------
    */

    const confirmAttendanceAction = async () => {

        const result = await Swal.fire({
            icon: "question",
            title: attendanceAction.text,
            text: attendanceAction.description,
            showCancelButton: true,
            confirmButtonText: "Yes, Continue",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            handleAttendanceAction();
        }

    };


    /*
    |--------------------------------------------------------------------------
    | ATTENDANCE CARDS
    |
    | key   = filter value
    | label = card ka naam
    | value = number (API se)
    | color = bootstrap color (primary, success, danger, warning...)
    |--------------------------------------------------------------------------
    */

    const attendanceCards = [

        { key: "", label: "Active Student", value: data?.total ?? 0, color: "primary" },

        { key: "1", label: "Present", value: data?.present ?? 0, color: "success" },

        { key: "2", label: "Absent", value: data?.absent ?? 0, color: "danger" },

        { key: "0", label: "Not Marked", value: data?.no_mark ?? 0, color: "warning" },

    ];


    /*
    |--------------------------------------------------------------------------
    | PUSH CARDS
    |--------------------------------------------------------------------------
    */

    const pushCards = [

        { key: "push_not_send", label: "Not Send", value: data?.push_not_send ?? 0, color: "secondary" },

        { key: "push_send", label: "Send", value: data?.push_send ?? 0, color: "success" },

        { key: "push_processing", label: "Processing", value: data?.push_processing ?? 0, color: "warning" },

        { key: "push_failed", label: "Failed", value: data?.push_failed ?? 0, color: "danger" },

    ];


    /*
    |--------------------------------------------------------------------------
    | META CARDS
    |--------------------------------------------------------------------------
    */

    const metaCards = [

        { key: "meta_not_send", label: "Not Send", value: data?.not_send ?? 0, color: "secondary" },

        { key: "meta_send", label: "Send", value: data?.send ?? 0, color: "success" },

        { key: "meta_processing", label: "Processing", value: data?.processing ?? 0, color: "warning" },

        { key: "meta_failed", label: "Failed", value: data?.failed ?? 0, color: "danger" },

    ];


    /*
    |--------------------------------------------------------------------------
    | ATTENDANCE FILTER
    |--------------------------------------------------------------------------
    */

    const setAttendanceFilter = (value) => {

        setFilters((prev) => ({
            ...prev,
            attendance: value,
            message_filter: "",
        }));

    };


    /*
    |--------------------------------------------------------------------------
    | MESSAGE FILTER
    |--------------------------------------------------------------------------
    */

    const setMessageFilter = (value) => {

        setFilters((prev) => ({
            ...prev,
            message_filter: value,
            attendance: "",
        }));

    };


    /*
    |--------------------------------------------------------------------------
    | CLEAR FILTER
    |--------------------------------------------------------------------------
    */

    const clearAllFilter = () => {

        setFilters((prev) => ({
            ...prev,
            attendance: "",
            message_filter: "",
        }));

    };


    /*
    |--------------------------------------------------------------------------
    | STAT BOX  (ek chhota card: upar label, uske NICHE value)
    |
    | flex-column = label upar, value niche
    | Active hone par solid color, warna sirf border.
    |--------------------------------------------------------------------------
    */

    const StatBox = ({
        item,
        active = false,
        onClick,
    }) => {

        return (

            <div
                role="button"
                onClick={onClick}
                className={`
                    d-flex
                    flex-column
                    justify-content-center
                    rounded
                    border
                    px-3
                    py-2
                    h-100
                    ${active
                        ? `bg-${item.color} border-${item.color} text-white`
                        : `bg-label-${item.color} border-${item.color}`
                    }
                `}
            >

                {/* LABEL (upar) */}
                <div className="small fw-medium text-truncate">

                    {item.label}

                </div>

                {/* VALUE (label ke niche) */}
                <div className="fs-4 fw-semibold lh-sm">

                    {item.value}

                </div>

            </div>

        );

    };


    /*
    |--------------------------------------------------------------------------
    | SECTION CARD  (Attendance / Push / Meta ka ek bada card)
    |
    | type = "attendance" | "push" | "meta"
    | Is function me decide hota hai ki kaunsa card active hai
    | aur click par kaunsa filter lagega.
    |--------------------------------------------------------------------------
    */

    const SectionCard = ({
        title,
        icon,
        color,
        cards,
        type,
    }) => {

        return (

            <div className="card h-100">

                <div className="card-body p-3">

                    {/* HEADING */}
                    <div className="d-flex align-items-center gap-2 mb-3">

                        <span className={`badge rounded-pill bg-label-${color} p-2`}>

                            <i className={`${icon} fs-5`} />

                        </span>

                        <div>

                            <h6 className="mb-0">{title}</h6>

                            <small className="text-muted">
                                Click a card to filter
                            </small>

                        </div>

                    </div>


                    {/* 4 BOXES */}
                    <div className="row g-2">

                        {cards.map((item) => {

                            let active = false;

                            let onClick;


                            /* ATTENDANCE */

                            if (type === "attendance") {

                                active =
                                    filters?.attendance === item.key &&
                                    !filters?.message_filter;

                                onClick = () =>
                                    setAttendanceFilter(item.key);

                            }

                            /* PUSH */

                            if (type === "push") {

                                active =
                                    filters?.message_filter === item.key;

                                onClick = () =>
                                    setMessageFilter(item.key);

                            }


                            /* META */

                            if (type === "meta") {

                                active =
                                    filters?.message_filter === item.key;

                                onClick = () =>
                                    setMessageFilter(item.key);

                            }



                            return (

                                <div
                                    className="col-6 col-sm-3"
                                    key={item.key}
                                >

                                    <StatBox
                                        item={item}
                                        active={active}
                                        onClick={onClick}
                                    />

                                </div>

                            );

                        })}

                    </div>

                </div>

            </div>

        );

    };


    /*
    |--------------------------------------------------------------------------
    | STATUS MAP
    |
    | 1 = Send
    | 2 = Not Send
    | 3 = Processing
    | 4 = Failed
    |--------------------------------------------------------------------------
    */

    const STATUS_MAP = {

        1: { text: "Send", cls: "bg-label-success", icon: "ri-check-line" },

        2: { text: "Not Send", cls: "bg-label-secondary", icon: "ri-subtract-line" },

        3: { text: "Processing", cls: "bg-label-warning", icon: "ri-time-line" },

        4: { text: "Failed", cls: "bg-label-danger", icon: "ri-close-line" },

    };


    /*
    |--------------------------------------------------------------------------
    | STATUS PILL  (IN: Send  /  OUT: Failed  jaisa chhota badge)
    |--------------------------------------------------------------------------
    */

    const StatusPill = ({
        label,
        status,
    }) => {

        const value = Number(status);

        const meta =
            STATUS_MAP[value] ??
            STATUS_MAP[2];

        return (

            <span
                className={`
                    badge
                    ${meta.cls}
                    d-inline-flex
                    align-items-center
                    gap-1
                `}
            >

                <i className={meta.icon} />

                {label}: {meta.text}

            </span>

        );

    };


    /*
    |--------------------------------------------------------------------------
    | MESSAGE ROW  (label aur pills EK HI LINE me)
    |
    | Example:   App :  [IN: Send] [OUT: Not Send]
    |
    | d-flex + flex-wrap = ek line me rahega, jagah kam ho to hi niche jayega.
    |--------------------------------------------------------------------------
    */

    const MessageRow = ({
        title,
        children,
    }) => {

        return (

            <div
                className="
                    d-flex
                    align-items-center
                    flex-wrap
                    gap-2
                    mb-2
                "
            >

                <span className="fw-semibold">

                    {title} :

                </span>

                {children}

            </div>

        );

    };


    /*
    |--------------------------------------------------------------------------
    | RENDER
    |--------------------------------------------------------------------------
    */

    return (

        <>

            {loading && <LoadingDiv />}


            {/* =====================================================
                DASHBOARD STATUS (3 cards)

                Meta band ho to 2 cards: col-xl-6
                Meta chalu ho to 3 cards: col-xl-4
            ====================================================== */}

            <div className="row g-3">

                {/* ATTENDANCE */}
                <div className={metaEnabled ? "col-12 col-xl-4" : "col-12 col-xl-6"}>

                    <SectionCard
                        title="Attendance"
                        icon="ri-calendar-check-line"
                        color="primary"
                        cards={attendanceCards}
                        type="attendance"
                    />

                </div>


                {/* PUSH */}
                <div className={metaEnabled ? "col-12 col-xl-4" : "col-12 col-xl-6"}>

                    <SectionCard
                        title="Push Notification"
                        icon="ri-notification-3-line"
                        color="info"
                        cards={pushCards}
                        type="push"
                    />

                </div>


                {/* META WHATSAPP (sirf enabled hone par) */}
                {metaEnabled && (

                    <div className="col-12 col-xl-4">

                        <SectionCard
                            title="Meta WhatsApp"
                            icon="ri-whatsapp-line"
                            color="success"
                            cards={metaCards}
                            type="meta"
                        />

                    </div>

                )}

            </div>


            {/* =====================================================
                ACTION BUTTONS
            ====================================================== */}

            <div
                className="
                    d-flex
                    align-items-center
                    justify-content-end
                    gap-2
                    mt-3
                    flex-wrap
                "
            >

                {(
                    filters?.attendance !== "" ||
                    filters?.message_filter
                ) && (

                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={clearAllFilter}
                            disabled={loading}
                        >

                            <i className="ri-close-line me-1" />

                            Clear Filter

                        </button>

                    )}


                <button
                    type="button"
                    className={attendanceAction.className}
                    onClick={confirmAttendanceAction}
                    disabled={loading}
                >

                    <i className={`${attendanceAction.icon} me-1`} />

                    {attendanceAction.text}

                </button>

            </div>


            {/* =====================================================
                STUDENT LIST
            ====================================================== */}

            <div className="card mt-3" >


                {/* HEADER */}

                <div
                    className="
                        card-header
                        d-flex
                        justify-content-between
                        align-items-center
                        flex-wrap
                        gap-2
                        py-3
                    "
                >

                    <div>

                        <h5 className="mb-0">

                            Student Attendance List

                        </h5>

                        <small className="text-muted">

                            {filters?.date}

                        </small>

                    </div>


                    <span className="badge bg-label-primary fs-6">

                        {data?.data?.length ?? 0} Students

                    </span>

                </div>


                {/* TABLE */}

                <div className="table-responsive" id="PrintDiv1">

                    <table className="table table-hover align-middle mb-0 text-nowrap">

                        <thead className="table-light">

                            <tr>

                                <th>#</th>

                                <th>Student</th>

                                <th>Batch</th>

                                <th>Attendance</th>

                                <th>Messages</th>

                            </tr>

                        </thead>


                        <tbody>

                            {data?.data?.length > 0 ? (

                                data.data.map((item, index) => {

                                    const attendance =
                                        item?.today_attendance;

                                    const checkIn =
                                        Number(attendance?.check_in);


                                    return (

                                        <tr key={item?.id}>


                                            {/* ---------- # ---------- */}

                                            <td className="text-muted">

                                                {index + 1}

                                            </td>


                                            {/* ---------- STUDENT ---------- */}

                                            <td>

                                                <Link
                                                    to={`/student/details?id=${item?.id}`}
                                                    className="fw-semibold text-decoration-none"
                                                >

                                                    {item?.name}

                                                </Link>

                                                <small className="d-block text-muted">

                                                    ({item?.registration_no ?? "-"})

                                                </small>

                                                <small className="d-block text-muted">

                                                    Mo. {item?.phone ?? "-"}

                                                </small>

                                            </td>


                                            {/* ---------- BATCH ---------- */}

                                            <td>

                                                <span className="badge bg-label-info">

                                                    {item?.latest_course_and_fee?.batch?.title ?? "-"}

                                                </span>

                                            </td>


                                            {/* ---------- ATTENDANCE ---------- */}

                                            <td>

                                                {checkIn === 1 ? (

                                                    /* PRESENT */
                                                    <>

                                                        <span className="badge bg-label-success mb-1">

                                                            Present

                                                        </span>

                                                        {attendance?.check_in_time && (

                                                            <small className="d-block text-muted">

                                                                In: {formatToTime(attendance.check_in_time)}

                                                            </small>

                                                        )}

                                                        {attendance?.check_out_time && (

                                                            <small className="d-block text-muted">

                                                                Out: {formatToTime(attendance.check_out_time)}

                                                            </small>

                                                        )}

                                                    </>

                                                ) : checkIn === 2 ? (

                                                    /* ABSENT */
                                                    <span className="badge bg-label-danger">

                                                        Absent

                                                    </span>

                                                ) : (

                                                    /* NOT MARKED */
                                                    <span className="badge bg-label-warning">

                                                        Not Marked

                                                    </span>

                                                )}

                                            </td>


                                            {/* ---------- MESSAGES ---------- */}

                                            <td>


                                                <MessageRow title={
                                                    <>
                                                        <i className="ri-notification-3-line me-1 "></i>
                                                        App
                                                    </>
                                                }>

                                                    {checkIn === 2 ? (

                                                        <StatusPill
                                                            label="Status"
                                                            status={attendance?.push_message_status}
                                                        />

                                                    ) : (

                                                        <>

                                                            <StatusPill
                                                                label="IN"
                                                                status={attendance?.push_in_message_status}
                                                            />

                                                            <StatusPill
                                                                label="OUT"
                                                                status={attendance?.push_out_message_status}
                                                            />

                                                        </>

                                                    )}

                                                </MessageRow>


                                                {metaEnabled && (

                                                    <MessageRow
                                                        title={
                                                            <>
                                                                <i className="ri-whatsapp-line me-1"></i>
                                                                WhatsApp
                                                            </>
                                                        }
                                                    >

                                                        {checkIn === 2 ? (

                                                            <StatusPill
                                                                label="Status"
                                                                status={attendance?.message_status}
                                                            />

                                                        ) : (

                                                            <>

                                                                <StatusPill
                                                                    label="IN"
                                                                    status={attendance?.in_message_status}
                                                                />

                                                                <StatusPill
                                                                    label="OUT"
                                                                    status={attendance?.out_message_status}
                                                                />

                                                            </>

                                                        )}

                                                    </MessageRow>

                                                )}

                                            </td>

                                        </tr>

                                    );

                                })

                            ) : (

                                <tr>

                                    <td
                                        colSpan={5}
                                        className="text-center py-5"
                                    >

                                        <i className="ri-inbox-line fs-1 text-muted d-block mb-2" />

                                        <span className="text-muted">

                                            No attendance data found

                                        </span>

                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>

            </div>

        </>

    );

}